module.exports = __webpack_public_path__ + "img/tab-image1.1a58f5a2.png";